export const DEFAULT_ERROR = { details: {}, title: '', visible: false, style: { borderColor: 'red' }, missingFields: [] }
export const DEFAULT_STYLE = { borderColor: 'lightgray' }
